import updateDocument from 'api/v2/repository/updateDocument';
import { useTranslation } from 'react-i18next';
import useMutation from 'hooks/react-query/useMutation';
import useQueryClient from 'hooks/react-query/useClientQuery';

import { DocumentsRepositoryCacheKeys } from 'types/cacheKeys.types';
import showToast from 'utils/toast';

const useUpdateDocument = (hideToast?: boolean) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const updateDocumentAPI = useMutation({
    mutationFn: updateDocument,
    onSuccess: () => {
      if (!hideToast) {
        showToast(
          { title: t('repository.updating_docs.success_msg') },
          { type: 'success' },
        );
      }

      queryClient.invalidateQueries([
        DocumentsRepositoryCacheKeys.DocumentsList,
      ]);
    },
  });

  return updateDocumentAPI;
};

export default useUpdateDocument;
